import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'getCampaignUnassignedEmails'

export default () => (asyncAction(
  name,
  CampaignsService.getCampaignUnassignedEmails
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/getCampaignUnassignedEmails.js